import { connect } from 'react-redux';
import { compose } from 'recompose';

import { fetchSettings } from './reducer/actions';
import { getShopBrandId } from '../../../../auth/selectors';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  loadingMailchimpSettings: state.mailchimp.mailchimpSettings.loading,
  mailchimpSettings: state.mailchimp.mailchimpSettings.settings,
  mailchimpConnectionState: state.mailchimp.mailchimpConnectionState,
});

const mapDispatchToProps = {
  fetchSettings,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
);
